import { render, staticRenderFns } from "./iframe.vue?vue&type=template&id=60bd8761&scoped=true"
import script from "./iframe.vue?vue&type=script&lang=js"
export * from "./iframe.vue?vue&type=script&lang=js"
import style0 from "./iframe.vue?vue&type=style&index=0&id=60bd8761&prod&lang=scss&scoped=true"
import style1 from "./iframe.vue?vue&type=style&index=1&id=60bd8761&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bd8761",
  null
  
)

export default component.exports